import React from 'react'
import { ComponentConsumerProps, TextField, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import TagList from './TagList'
import { TagProps } from '../../page-components/TagTopics/types'

type RelatedTopicsProps = ComponentConsumerProps & {
  fields: {
    tags: TagProps[]
    title: string
    fallback: boolean
  }
}

const RelatedTopics = ({ fields: { tags, title, fallback } }: RelatedTopicsProps) => {
  if (fallback) {
    console.log("[RelatedTopics] - Using fallback datasource");
  }

  const titleProp = () => {
    if (title){
      return title;
    }
    var field: string = "Related Topics";
    return field;
  }

  return <TagList tags={tags} rootPath="/blog/tag/" title={titleProp()} />
}

export default withSitecoreContext()(RelatedTopics)
